import { Col, Form, Row } from 'react-bootstrap'

import { ContainerComponent, ContentComponent } from '../../styles'

export function Caracteristicas({ isVisible, product, handleChange }) {
  if (!isVisible) {
    return null
  }

  return (
    <ContainerComponent>
      <div>
        <ContentComponent>
          <h4>Características</h4>

          <Row className="mb-3">
            <Col>
              <Form.Label> Peso Líquido (em kg) </Form.Label>
              <Form.Control
                name="PESO_LIQUIDO"
                value={product.PESO_LIQUIDO}
                onChange={(e) => handleChange(e, 'caracteristicas')}
              />
            </Col>

            <Col>
              <Form.Label> Peso Bruto</Form.Label>
              <Form.Control
                name="PESO_BRUTO"
                value={product.PESO_BRUTO}
                onChange={(e) => handleChange(e, 'caracteristicas')}
              />
            </Col>

            <Col>
              <Form.Label>Largura</Form.Label>
              <Form.Control
                name="LARGURA"
                value={product.LARGURA}
                onChange={(e) => handleChange(e, 'caracteristicas')}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Altura</Form.Label>
              <Form.Control
                name="ALTURA"
                value={product.ALTURA}
                onChange={(e) => handleChange(e, 'caracteristicas')}
              />
            </Col>

            <Col>
              <Form.Label>Profundidade</Form.Label>
              <Form.Control
                name="PROFUNDIDADE"
                value={product.PROFUNDIDADE}
                onChange={(e) => handleChange(e, 'caracteristicas')}
              />
            </Col>

            <Col>
              <Form.Label>Unidade de medida</Form.Label>
              <Form.Select
                name="UNIDADE_MEDIDA"
                value={product.UNIDADE_MEDIDA}
                onChange={(e) => handleChange(e, 'caracteristicas')}
              >
                <option value="">Selecione uma Opção</option>
                <option value="CM">Centímetros</option>
                <option value="M">Metros</option>
                <option value="MM">Mílimetros</option>
              </Form.Select>
            </Col>
          </Row>
        </ContentComponent>
      </div>
    </ContainerComponent>
  )
}
